<template>
  <div class="content">
    <div class="con">
      <div class="top">
        <div class="top_con">
          <span>
            {{ payStatus == 0 || payStatus == 1 ? '请工程师确认订单并帮用户付款～' : ( payStatus == 2 ? 'TA完成了现金交易，您已代付成功啦～' : '代付订单已取消啦～')}}
          </span>
        </div>
      </div>
      <div class="content-center">
        <div :class="['totalMoney', payStatus == 3 ? 'totalMoney-paid' : '']">
          <img v-if="payStatus == 2" src="@/assets/img/paid.png" alt="">
          <img v-if="payStatus == 3" src="@/assets/img/canceled.png" alt="">
          <p class="p1">代付金额</p>
          <p class="p2">¥<span>{{integer}}.</span>{{decimals}}</p>
          <p class="p3" v-if="discountMoney != 0">优惠已减 ¥ {{discountMoney}}</p>
        </div>
        <div class="border">
          <div class="border-left"></div>
          <div class="border-right"></div>
        </div>
        <div class="orderMsg">
          <div class="title">
            <span class="title-left">代付订单信息</span>
            <div class="title-right" @click="showDialog = true">
              <img src="@/assets/img/gantanHao.png" alt="">
              <span>工程师代付说明</span>
            </div>
          </div>
          <!-- taro (注: taro单展示orderSubInfo数据 isOpen取orderSubInfo里的) -->
          <template v-if="methodType == 1">
            <div class="titleTaro">
              <span>订单编号</span>
              <span>{{dataList.length ? dataList[0].id : ''}}</span>
            </div>
            <block v-for="(ele,ind) in dataList" :key="ind">
              <div class="order_items" v-for="(item,index) in ele.orderSubInfo" :key="index">
                <div class="items_title">
                  <div class="items_title_left">
                    <span>{{item.goodsName}}</span>
                    <template v-if="item.serviceTypeList && item.serviceTypeList.length">
                      <span class="serverType" v-for="(x,k) in item.serviceTypeList" :key="k">{{x}}</span>
                    </template>
                  </div>
                  <div class="items_amount">
                    <span>¥{{item.payPrice}}</span>
                    <span :class="['iconfont', item.isOpen ? 'icon-xiangshangjiantou' : 'icon-xiangxiajiantou']" @click="item.isOpen = !item.isOpen"></span>
                  </div>
                </div>
                <p class="items_con">
                  <span class="p1">家电型号</span>
                  <span class="p2">
                    <span class="vib">{{item.vib}}</span> 
                    <span>/{{item.ki}} </span>
                    <span> {{item.fd}} </span>
                    <span> {{item.zn}}</span>
                  </span>
                </p>
                <p class="items_con" v-if="item.risCode">
                  <span class="p1">服务单号</span>
                  <span class="p2">{{item.risCode}}</span>
                </p>
                <div class="feesDetail" v-if="item.isOpen">
                  <p v-for="(x,k) in item.feeDetail" :key="k">
                    <span>{{x.name}}</span>
                    <span>¥{{x.fee}}</span>
                  </p>
                </div>
              </div>
            </block>
          </template>
          <!-- tss -->
          <template v-else>
            <div class="order_items" v-for="(item,index) in dataList" :key="index">
              <div class="items_title">
                <div class="items_title_left">
                  <span>{{item.orderSubInfo[0].categoryName}}</span>
                  <span class="serverType" v-if="item.serverType">
                    <template v-if="item.type == 8">{{'关怀套餐'}}</template>
                    <template v-else>{{matchServerType(item.serverType)}}</template>
                  </span>
                  <span class="tssCewYear" v-if="item.type == 7">
                    {{item.tssCewYear}}年·官方延保
                  </span>
                </div>
                <div class="items_amount">
                  <span>¥{{item.fee}}</span>
                  <span :class="['iconfont', item.isOpen ? 'icon-xiangshangjiantou' : 'icon-xiangxiajiantou']" @click="item.isOpen = !item.isOpen"></span>
                </div>
              </div>
              <p class="items_con">
                <span class="p1">家电型号</span>
                <span class="p2">
                  <span class="vib">{{item.orderSubInfo[0].vib}}</span> 
                  <span>/{{item.orderSubInfo[0].ki}} </span>
                  <span> {{item.orderSubInfo[0].fd}} </span>
                  <span> {{item.orderSubInfo[0].zn}}</span>
                </span>
              </p>
              <p class="items_con">
                <span class="p1">服务单号</span>
                <span class="p2">{{item.risCode}}</span>
              </p>
              <p class="items_con">
                <span class="p1">订单编号</span>
                <span class="p2">{{item.id}}</span>
              </p>
              <div class="feesDetail" v-if="item.isOpen">
                <p>
                  <span>上门费用</span>
                  <span>¥{{item.tssParerPrice}}</span>
                </p>
                <p>
                  <span>配件费用</span>
                  <span>¥{{item.tssLabourPrice}}</span>
                </p>
              </div>
            </div>
            <p class="order_footer" v-if="orderList.length > 1" @click="showOrderList">
              共<span>{{orderList.length}}</span>笔服务订单
              <i :class="['iconfont', !allOpen ? 'icon-xiangxiajiantou' : 'icon-xiangshangjiantou']"></i>
            </p>
          </template>
        </div>
      </div>
      <div style="height:50px;"></div>
    </div>
    <div class="footer" v-if="payStatus == 0 || payStatus == 1">
      <!-- 工程师 -->
      <div v-if="payStatus == 0" class="footer_pay cash" @click="confirmCash">确认收到现金</div>
      <div v-else class="footer_pay" @click="goPay">去付款</div>
    </div>

    <van-dialog v-model="showDialog" 
      :showCancelButton="false" 
      confirmButtonText="我知道了" 
      confirmButtonColor="#009999"
      title="工程师代付说明" 
      show-cancel-button>
      <div class="dialogCon" style="margin:15px 30px;">
        <p>1.请在
          <template v-if="methodType == 1">
            <span>{{showDate}}</span>
          </template>
          <template v-else>
            当天<span>22:59:59</span>
          </template>
        前完成支付</p>
        <p>2.与顾客进行现金交易时，请工程师务必确认收到款项~</p>
        <p>3.若发生退款，实付金额将原路退还给工程师的付款账户，再由工程师退还给顾客~</p>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import mixin from './mixin.js'
import { getJsapiSignature } from "@/api/api"
export default {
  mixins:[mixin],
  data() {
    return {
      showDialog: false,
      allOpen: false,
      orderList:[],
      dataList:[],
      isShow: false,
      payMoney: 0,
      discountMoney: 0,
      payStatus: null,//支付状态
      paramsData: {},
      agentConfig:null,
      methodType: '0',
      showDate:'',
    }
  },
  created() {},
  mounted() {},
  methods: {
    getSignture() {
      let params = {
        agentId: 1000088,
        url: location.href
        //url: location.href.split('#')[0]) 获取#之前的
      }
      getJsapiSignature(params).then( res => {
        console.log(res,'=========')
        if (res.data.code == 200) {
          this.paramsData = res.data.data
        }
      })
    },
    test() {
      let that = this
      console.log(that.paramsData,'======paramsData=====')
      wx.agentConfig({
        beta: true,
        debug: true,
        corpid: that.paramsData ? that.paramsData.corpid : '', // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentid: 1000088, // 必填，企业微信的应用id （e.g. 1000247）
        timestamp: that.paramsData.timestamp, // 必填，生成签名的时间戳
        nonceStr: that.paramsData.nonceStr, // 必填，生成签名的随机串
        signature: that.paramsData.signature,// 必填，签名，见附录-JS-SDK使用权限签名算法
        jsApiList: ['launchMiniprogram'], //必填，传入需要使用的接口名称
        success: function(res) {
          console.log(res,'========agentConfig========')
          wx.invoke('launchMiniprogram', {
            "appid" : "wx00e2750add150103", // 需跳转的小程序appid
            "path" : "pages/siemensindex/main", // 所需跳转的小程序内页面路径及参数。非必填
          }, function(result) {
            console.log(result,'========invoke=========')
            if(result.err_msg == "launchMiniprogram:ok") {
              // 正常
              // wx.closeWindow();
            } else {
              // 错误处理
            }
          });
        },
        fail: function(res) {
            console.log(res,'=========error===========')
            if(res.errMsg.indexOf('function not exist') > -1){
              alert('版本过低请升级')
            }
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
.content{
  height: 100vh;
  background:#EBF0F5;
  display: flex;
  flex-direction: column;
  .con{
    // height: calc(100% - 80px);
    height: calc(100vh - 80px);
    flex: 1;
    overflow-y: auto;
  }
  .top{
    height: 105px;
    background-image: url("../../assets/img/headerBg.png");
    background-size: 100% 100%;
    color: #fff;
    font-size: 14px;
    padding: 22px 16px 0 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 40px;
  }
  .content-center{
    margin: 0 16px;
    background: #fff;
    border-radius: 5px;
  }
  .totalMoney{
    margin: -30px 0 0;
    height: 120px;
    text-align: center;
    padding-top: 15px;
    position: relative;
    img{
      width: 85px;
      height: 85px;
      position: absolute;
      right: -15px;
      top: -15px;
    }
    .p1 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #879BAA;
    }
    .p2 {
      color: #009999;
      span{font-size: 28px;}
      font-weight: bolder;
      padding: 16px 0 8px;
    }
    .p3 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #879BAA;
    }
  }
  .totalMoney-paid{
    p{opacity: 0.5;}
  }
  .border{
    border-top: 1px dashed #ccc;
    margin: 0 16px;
    position: relative;
  }
  .border-left{
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #EBF0F5;
    left: -20px;
    top: -6px;
  }
  .border-right{
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    right: -20px;
    top: -6px;
    background: #EBF0F5;
  }
  .orderMsg{
    margin: 0px 0 20px;
    padding: 0 16px;
    .title{
      font-size: 12px;
      font-weight: bolder;
      padding: 15px 0;
      color: #879BAA;
      display: flex;
      align-items: center;
      .title-right{
        img{
          width: 12px;
          height: 12px;
          position: relative;
          top: 1px;
          right: 5px;
        }
        margin-left: auto;
        display: inline-block;
        color: #009999;
      }
    }
    .order_items{
      padding: 15px 0;
      .items_title{
        display: flex;
        align-items: center;
        .items_title_left{
          span:nth-child(1){
            font-weight: bolder;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            color: #333333;
          }
          .serverType{
            display: inline-block;
            background: #F2F2F2;
            font-size: 13px;
            color: #009999;
            padding: 6px;
            margin-left: 10px;
            border-radius: 2px;
          }
          .tssCewYear{
            display: inline-block;
            height: 18px;
            line-height: 18px;
            padding: 0 5px;
            background: rgba(#FA6400, 0.07);
            border-radius: 2px;
            font-size: 12px;
            font-weight: bold;
            color: #FA6400;
            margin-left: 10px;
            .tssCewYear-num{
              font-size: 15px;
              color: #FA6400;
              font-weight: bolder;
            }
          }
        }
        .items_amount{
          // text-align: right;
          margin-left: auto;
          font-size: 13px;
          font-weight: 500;
          color: #009999;
          span{
            display: inline-block;
          }
          .iconfont {
            font-size: 14px;
            padding-left: 5px;
            font-weight: bold;
            color: #879BAA;
            vertical-align: middle;
          }
        }
      }
      .items_con{
        padding: 12px 0 0 0;
        color: #ccc;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #2D373C;
        .p1{
          display: inline-block;
          padding-right: 10px;
        }
        .p2 {
          color: #879BAA;
          .vib{color:#333;}
        }
      }
      .feesDetail{
        padding:12px 16px;
        font-size: 16px;
        background: #F9F9F9;
        margin-top: 10px;
        p{
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #2D373C;
          display: flex;
          line-height: 20px;
          margin-bottom: 10px;
          span:nth-child(2){
            margin-left: auto;
          }
        }
        p:last-child{
          margin-bottom: 0px;
        }
      }
    }
    // 
    .orderservice_items {
      padding: 15px 0;
      display: flex;
      .orderService {
        flex: 1;
        margin-left: 24px;
        padding-top: 0px;
        .orderService-p1 {
          span:nth-child(1) {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 700;
            color: #333333;
            line-height: 18px;
          }
          span:nth-child(2) {
            display: inline-block;
            background: #e5f4f4;
            font-size: 12px;
            color: #009999;
            padding: 3px;
            margin-left: 5px;
            line-height: 18px;
          }
        }
        .orderService-p2 {
          margin: 6px 0;
          color: #2d373c;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          span:nth-child(2) {
            color: #879baa;
          }
        }
        .orderService-p3 {
          font-size: 13px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 700;
          color: #2d373c;
          line-height: 18px;
        }
      }
  }
  .titleTaro{
    font-size: 12px;
    font-weight: bolder;
    color: #879BAA;
    padding: 10px 0 15px;
    span:nth-of-type(2){
      display: inline-block;
      padding-left: 20px;
    }
  }
  }
  .order_footer{
    text-align: center;
    padding: 10px 0;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #009999;
    span{font-size: 16px;}
    .iconfont{
      font-weight: bold;
      color: #879BAA;
      font-size: 12px;
    }
  }
  .footer{
    height: 80px;
    width: 100%;
    background: #fff;
    position: fixed; 
    bottom: 0;
    padding: 0 16px;
    .footer_pay{
      text-align: center;
      display: inline-block;
      margin-top: 15px;
      font-size: 16px;
      border-radius: 8px;
      width: 100%;
      height: 48px;
      line-height: 48px;
      background: #009999;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bolder;
      color: #FFFFFF;
    }
    .cash{
      border: 2px solid #009999;
      color: #009999;
      background: #fff;
    }
  }
  /deep/ .van-dialog__header{
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bolder;
    color: #000000;
  }
  .dialogCon{
    margin: 15px 30px;
    color: #879BAA;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    p{
      font-size:16px;
      line-height:24px;
      span{color:#009999;}
    }
  }
}
</style>